import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  public newMessage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}

